import React from 'react'
import styled from 'styled-components'

const Red = styled.span`
  color: #ed5757;
`

const getFormLabel = (text: string) => {
  // if (required) is in string, replace it with a red asterisk
  if (text.includes('(required)')) {
    return (
      <>
        {text.replace('(required)', '')} <Red>*</Red>
      </>
    )
  }
  return text
}
export default getFormLabel
